import { WeavePayPage } from '@frontend/payments';

export const WeavePayApp = () => <WeavePayPage />;

export default WeavePayApp;
